import { Item, WalletName } from "../models";
import { PaymentMethod } from "@stripe/stripe-js";

function getTestsOrdered(orderItems?: Item[]): string {
  if (!orderItems) return "";

  let testNames = orderItems
    .map((item) => item.testName?.shortName)
    .filter(Boolean)
    .join(", ");

  if (testNames === "Horizon, Panorama") testNames = "Panorama, Horizon";
  return testNames ?? "";
}

function getLimsClinicIds(orderItems?: Item[]): string {
  if (!orderItems) return "";

  return (
    orderItems
      .map((item) => item.clinicId)
      .filter(Boolean)
      .join(", ") ?? ""
  );
}

function getWalletType(paymentMethod?: PaymentMethod): WalletName {
  const walletType = paymentMethod?.card?.wallet?.type;

  if (walletType === "apple_pay") return WalletName.APPLE_PAY;
  if (walletType === "google_pay") return WalletName.GOOGLE_PAY;
  return WalletName.CARD;
}

export { getTestsOrdered, getLimsClinicIds, getWalletType };
